import { isMobileNavigator } from './isMobileNavigator';

/** 移动端 viewport 缩放配置，对齐 pc-lai H5 方案 */
export const MOBILE_VIEWPORT_CONTENT =
  'width=device-width, initial-scale=0.31, maximum-scale=1, minimum-scale=0.2, user-scalable=yes';

const getViewportMeta = (): HTMLMetaElement | null => {
  return document.querySelector('meta[name="viewport"]');
};

/**
 * 移动端访问时调整 viewport，将 PC 页面整体缩放以适配手机屏幕。
 * 应在 React 挂载前调用，避免首屏闪烁。
 */
export function setupMobileViewport(): void {
  if (!isMobileNavigator()) {
    return;
  }

  const viewport = getViewportMeta();
  if (viewport) {
    viewport.setAttribute('content', MOBILE_VIEWPORT_CONTENT);
  }

  document.documentElement.classList.add('is-mobile-navigator');
}
